import tenant from '@/config/tenant'
import Vue from 'vue'
import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

window.Pusher = Pusher

const echo = new Echo({
  broadcaster: 'pusher',
  // Mesma base do axios: /broadcasting/auth passa pelo middleware 'tenant'
  // (InitializeTenancyBySubdomain) e responde 500 se vier pelo domínio central.
  authEndpoint: `${tenant.buildTenantUrl()}/broadcasting/auth`,
  auth: {
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('app-token')}`,
      // Define o banco central (usuário e domínio do tenant); sem ele cai em 'bra'.
      country: window.localStorage.getItem('country-code') || 'bra'
    }
  },
  cluster: 'mt1',
  key: process.env.VUE_APP_PUSHER_KEY,
  wsHost: process.env.VUE_APP_PUSHER_HOST,
  wsPort: 6001,
  wssPort: 443,
  forceTLS: false,
  encrypted: true,
  disableStats: true,
  enabledTransports: ['ws', 'wss']
})

Vue.prototype.$echo = echo
export default Vue
